var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: [_vm.$root.deviceType], attrs: { id: "globalsearch" } },
    [
      !this.$root.isNutriverse
        ? _c("div", { staticClass: "searchBarContainer" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchTerm,
                  expression: "searchTerm"
                }
              ],
              ref: "searchInput",
              staticClass: "searchField searchInput",
              attrs: { placeholder: this.$root.language.wsm_Search },
              domProps: { value: _vm.searchTerm },
              on: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.search("enter")
                },
                input: [
                  function($event) {
                    if ($event.target.composing) return
                    _vm.searchTerm = $event.target.value
                  },
                  function($event) {
                    return _vm.search("wait")
                  }
                ]
              }
            }),
            !_vm.loading ? _c("i", { staticClass: "fal fa-search" }) : _vm._e(),
            _vm.loading
              ? _c("i", { staticClass: "fas fa-spinner fa-pulse" })
              : _vm._e()
          ])
        : _vm._e(),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.searchTerm != "" &&
              !_vm.loading &&
              _vm.timer == null &&
              _vm.show,
            expression: "searchTerm != '' && !loading && timer == null && show"
          }
        ],
        staticClass: "backdrop",
        on: {
          click: function($event) {
            _vm.show = false
          }
        }
      }),
      _c(
        "transition",
        { attrs: { name: "fadeInUp", duration: { enter: 500, leave: 0 } } },
        [
          _c("result", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.searchTerm != "" &&
                  !_vm.loading &&
                  _vm.timer == null &&
                  _vm.show,
                expression:
                  "searchTerm != '' && !loading && timer == null && show"
              }
            ],
            attrs: {
              loading: _vm.loading,
              showLoader: _vm.showLoader,
              result: _vm.searchResult
            },
            on: { scroll: _vm.handleResultScroll }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }